define([
	"dojo/_base/declare",
	"csi/action/SelectOneController",
	"csi/session",
], function(declare, SelectOneController, session) {

	return declare(SelectOneController, {
		/** @property {boolean} compare - indicates a compare url */
		compare: false,

		/**
		 * @override
		 * Only Close action is needed
		 */
		addProxyActions(defView, defActions) {
			defActions.addAction(this.getProxyAction("Close"));
		},

		/**
		 * @override
		 * Make view editable, set initial value and react to select event
		 */
		onFormData(fd) {
			fd.m_bEditable = true;
			fd.addAggregatedNode(this.widget.getRevisionNode());
		},

		/**
		 * @override
		 * Navigate to selected revision
		 */
		onEnd() {
			const {compare, m_formData, widget} = this;
			const newRevision = m_formData.getSelectedNode();
			const oldRevision = widget.getRevisionNode();

			if (oldRevision !== newRevision) {
				session.setLocationKey(compare ? session.LOCATION_COMPARE_URL : session.LOCATION_REVISION_URL, newRevision?.$URL, true);
			}
		}
	});
});